import { MouseEventHandler, ReactNode } from 'react';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { A, Box } from '@bridebook/ui';
import { IconLocationMarker } from '@bridebook/ui/src/icons';
import { formatShortAddress } from '@bridebook/web/app-shared/lib/supplier/utils';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';
import componentStyles from './supplier-head-location.style';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

interface IProps {
  supplier: ISupplier;
  onLocationClick: MouseEventHandler<ReactNode>;
  locationPinInfo?: IBreadcrumbItem[];
  Icon?: ReactNode;
}

const SupplierHeadLocation = ({ supplier, onLocationClick, locationPinInfo, Icon }: IProps) => {
  const supplierShortAddress = formatShortAddress(supplier);
  const market = useMarket();

  const styles = componentStyles();

  return (
    <Box style={styles.wrapper} onClick={onLocationClick}>
      {Icon ?? <IconLocationMarker color="silver" />}
      <Box style={styles.text} title={supplierShortAddress ?? undefined}>
        {locationPinInfo
          ? locationPinInfo.map((item, index) =>
              item.path ? (
                <A
                  noUnderline
                  key={item.id}
                  flexDirection="row"
                  href={`/${market.prefix}${item.path}`}
                  color="space60">
                  {item.name}
                  {index < locationPinInfo.length - 1 && <Box>,&nbsp;</Box>}
                </A>
              ) : null,
            )
          : supplierShortAddress}
      </Box>
    </Box>
  );
};

export default SupplierHeadLocation;
